import { render } from "./PdpProductImagePanel.vue?vue&type=template&id=0fca3a96"
import script from "./PdpProductImagePanel.vue?vue&type=script&lang=js"
export * from "./PdpProductImagePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__